<template>
  <div class="admin-speakers">
    <!-- 搜索和筛选区域 -->
    <div class="search-section">
      <el-card>
        <div class="search-form">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input v-model="searchForm.keyword" :placeholder="$t('admin.speakers.search.placeholder')" clearable
                @keyup.enter="handleSearch">
                <template #prefix>
                  <el-icon>
                    <Search />
                  </el-icon>
                </template>
              </el-input>
            </el-col>
            <!-- <el-col :span="4">
              <el-select
                v-model="searchForm.status"
                :placeholder="$t('admin.speakers.search.status')"
                clearable
              >
                <el-option
                  :label="$t('admin.speakers.status.active')"
                  value="active"
                />
                <el-option
                  :label="$t('admin.speakers.status.inactive')"
                  value="inactive"
                />
              </el-select>
            </el-col> -->
            <el-col :span="4">
              <el-button type="primary" @click="handleSearch">
                <el-icon>
                  <Search />
                </el-icon>
                {{ $t('admin.speakers.search.button') }}
              </el-button>
              <el-button @click="handleReset">
                <el-icon>
                  <Refresh />
                </el-icon>
                {{ $t('common.refresh') }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>

    <!-- 操作按钮区域 -->
    <div class="action-section">
      <el-card>
        <div class="action-buttons">
          <el-button type="primary" @click="handleAdd">
            <el-icon>
              <Plus />
            </el-icon>
            {{ $t('admin.speakers.actions.add') }}
          </el-button>
          <el-button type="success" @click="handleRefresh">
            <el-icon>
              <Refresh />
            </el-icon>
            {{ $t('admin.speakers.actions.refresh') }}
          </el-button>
        </div>
      </el-card>
    </div>

    <!-- 数据表格 -->
    <div class="table-section">
      <el-card>
        <el-table v-loading="loading" :data="tableData" stripe border style="width: 100%"
          :empty-text="$t('admin.speakers.table.noData')">
          <el-table-column prop="id" :label="$t('admin.speakers.table.id')" width="80" align="center" />
          <el-table-column prop="avatar" :label="$t('admin.speakers.table.avatar')" width="100" align="center">
            <template #default="{ row }">
              <el-avatar :size="50" :src="previewFile(row.avatar)" :alt="row.name_en || row.name_zh">
                <el-icon>
                  <User />
                </el-icon>
              </el-avatar>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="name_zh" :label="$t('admin.speakers.table.nameZh')" width="200" /> -->
          <el-table-column prop="name_en" :label="$t('admin.speakers.table.nameEn')" width="300" />
          <!-- <el-table-column prop="bio_zh" :label="$t('admin.speakers.table.bioZh')" width="300" show-overflow-tooltip /> -->
          <el-table-column prop="bio_en" :label="$t('admin.speakers.table.bioEn')" width="400" show-overflow-tooltip />
          <el-table-column prop="sort_order" :label="$t('admin.speakers.table.sortOrder')" width="120" align="center">
            <template #default="{ row }">
              <el-tag :type="row.sort_order ? 'primary' : 'info'" size="small">
                {{ row.sort_order || '-' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="video" :label="$t('admin.speakers.table.video')" width="150" align="center">
            <template #default="{ row }">
              <el-tag :type="(row.video_path || row.video_url) ? 'success' : 'info'" size="small">
                {{ (row.video_path || row.video_url) ? $t('admin.speakers.table.hasVideo') :
                  $t('admin.speakers.table.noVideo') }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" :label="$t('admin.speakers.table.createdAt')" width="180" align="center">
            <template #default="{ row }">
              {{ formatDate(row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('admin.speakers.table.actions')" align="center" fixed="right">
            <template #default="{ row }">
              <el-button type="primary" size="small" @click="handleView(row)">
                {{ $t('admin.speakers.table.view') }}
              </el-button>
              <el-button type="warning" size="small" @click="handleEdit(row)">
                {{ $t('admin.speakers.table.edit') }}
              </el-button>
              <el-button type="danger" size="small" @click="handleDelete(row)">
                {{ $t('admin.speakers.table.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-section">
          <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange" @current-change="handleCurrentChange">
            <template #total>
              {{ $t('admin.speakers.pagination.total', { total: pagination.total }) }}
            </template>
          </el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog v-model="detailVisible" :title="$t('admin.speakers.modal.title')" width="900px"
      :close-on-click-modal="false" class="speaker-detail-dialog">
      <div v-if="currentRecord" class="detail-content">
        <!-- 头部信息区域 -->
        <div class="speaker-header">
          <div class="avatar-section">
            <el-avatar :size="120" :src="previewFile(currentRecord.avatar)" :alt="currentRecord.name_zh"
              class="speaker-avatar">
              <el-icon size="40">
                <User />
              </el-icon>
            </el-avatar>
          </div>
          <div class="basic-info">
            <h2 class="speaker-name">{{ currentRecord.name_zh }}</h2>
            <h3 v-if="currentRecord.name_en" class="speaker-name-en">{{ currentRecord.name_en }}</h3>
            <div class="speaker-id">
              <el-tag type="info" size="small">ID: {{ currentRecord.id }}</el-tag>
            </div>
            <div class="created-time">
              <el-icon>
                <Clock />
              </el-icon>
              <span>{{ $t('admin.speakers.table.createdAt') }}: {{ formatDate(currentRecord.created_at) }}</span>
            </div>
          </div>
        </div>

        <!-- 简介区域 -->
        <div class="bio-section">
          <h3 class="section-title">
            <el-icon>
              <Document />
            </el-icon>
            {{ $t('admin.speakers.table.bioZh') }}
          </h3>
          <div class="bio-content">
            <p>{{ currentRecord.bio_zh }}</p>
          </div>
        </div>

        <!-- 英文简介区域 -->
        <div v-if="currentRecord.bio_en" class="bio-section">
          <h3 class="section-title">
            <el-icon>
              <Document />
            </el-icon>
            {{ $t('admin.speakers.table.bioEn') }}
          </h3>
          <div class="bio-content">
            <p>{{ currentRecord.bio_en }}</p>
          </div>
        </div>

        <!-- 视频播放区域 -->
        <div v-if="currentRecord.video_path || currentRecord.video_url" class="video-section">
          <h3 class="section-title">
            <el-icon>
              <VideoPlay />
            </el-icon>
            {{ $t('admin.speakers.modal.video') }}
          </h3>
          <div class="video-container">
            <video :src="currentRecord.video_url || previewFile(currentRecord.video_path)" controls preload="metadata"
              class="speaker-video">
              {{ $t('admin.speakers.modal.videoNotSupported') }}
            </video>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="detailVisible = false" size="large">
            {{ $t('admin.speakers.modal.close') }}
          </el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 添加/编辑弹窗 -->
    <el-dialog v-model="formVisible"
      :title="isEdit ? $t('admin.speakers.form.editTitle') : $t('admin.speakers.form.addTitle')" width="600px"
      :close-on-click-modal="false">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="120px">
        <el-form-item :label="$t('admin.speakers.form.nameZh')" prop="name_zh">
          <el-input v-model="form.name_zh" :placeholder="$t('admin.speakers.form.nameZhPlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('admin.speakers.form.nameEn')" prop="name_en">
          <el-input v-model="form.name_en" :placeholder="$t('admin.speakers.form.nameEnPlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('admin.speakers.form.bioZh')" prop="bio_zh">
          <el-input v-model="form.bio_zh" type="textarea" :rows="4"
            :placeholder="$t('admin.speakers.form.bioZhPlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('admin.speakers.form.bioEn')" prop="bio_en">
          <el-input v-model="form.bio_en" type="textarea" :rows="4"
            :placeholder="$t('admin.speakers.form.bioEnPlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('admin.speakers.form.sortOrder')">
          <el-input-number v-model="form.sort_order" :min="1" :max="9999" :step="1" 
            :placeholder="$t('admin.speakers.form.sortOrderPlaceholder')" style="width: 100%;" />
        </el-form-item>
        <el-form-item :label="$t('admin.speakers.form.avatar')">
          <el-upload ref="avatarUploadRef" :auto-upload="false" :show-file-list="false" :on-change="handleAvatarChange"
            :before-upload="beforeAvatarUpload" accept="image/*" drag class="avatar-upload">
            <div class="upload-area">
              <el-icon class="upload-icon">
                <Upload />
              </el-icon>
              <div class="upload-text">
                <p>{{ $t('admin.speakers.form.uploadAvatar') }}</p>
                <p class="upload-hint">{{ $t('admin.speakers.form.uploadAvatarHint') }}</p>
              </div>
              <div v-if="form.avatar_temp_path" class="upload-success">
                <el-icon class="success-icon">
                  <Check />
                </el-icon>
                <span>{{ $t('admin.speakers.upload.avatarSuccess') }}</span>
              </div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('admin.speakers.form.video')">
          <div class="video-upload-section" style="width: 100%;">
            <!-- <el-upload
              ref="videoUploadRef"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleVideoChange"
              :before-upload="beforeVideoUpload"
              accept="video/*"
            >
              <div v-if="form.video_temp_path" class="video-preview">
                <video
                  :src="previewFile(form.video_temp_path)"
                  controls
                  style="width: 200px; height: 120px;"
                >
                  {{ $t('admin.speakers.modal.videoNotSupported') }}
                </video>
                <el-button type="text" @click.stop="form.video_temp_path = ''">
                  {{ $t('admin.speakers.form.removeVideo') }}
                </el-button>
              </div>
              <el-button v-else type="primary">
                <el-icon><Upload /></el-icon>
                {{ $t('admin.speakers.form.uploadVideo') }}
              </el-button>
            </el-upload> -->
            <div class="video-url-input">
              <el-input v-model="form.video_url" :placeholder="$t('admin.speakers.form.videoUrlPlaceholder')" clearable>
                <template #prepend>{{ $t('admin.speakers.form.videoUrl') }}</template>
              </el-input>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="formVisible = false">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button type="primary" @click="handleSave" :loading="saving">
          {{ $t('common.save') }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Search, Refresh, Plus, Upload, User, Clock, Document, VideoPlay, Check } from '@element-plus/icons-vue'
import { getSpeakers, createSpeaker, updateSpeaker, deleteSpeaker, uploadSpeakerAvatar, uploadSpeakerVideo } from '@/api/speaker'
import { previewFile } from '@/utils/uploadedPreview'
import { useI18n } from 'vue-i18n'

export default {
  name: 'AdminSpeakers',
  components: {
    Search,
    Refresh,
    Plus,
    Upload,
    User,
    Clock,
    Document,
    VideoPlay,
    Check
  },
  setup() {
    const { t } = useI18n()

    // 响应式数据
    const loading = ref(false)
    const saving = ref(false)
    const tableData = ref([])
    const detailVisible = ref(false)
    const formVisible = ref(false)
    const isEdit = ref(false)
    const currentRecord = ref(null)
    const formRef = ref(null)

    // 搜索表单
    const searchForm = reactive({
      keyword: ''
    })

    // 表单数据
    const form = reactive({
      name_zh: '',
      name_en: '',
      bio_zh: '',
      bio_en: '',
      avatar_temp_path: '',
      video_temp_path: '',
      video_url: '',
      sort_order: null
    })

    // 表单验证规则
    const formRules = {
      name_zh: [
        { min: 2, max: 100, message: t('admin.speakers.form.nameZhLength'), trigger: 'blur' }
      ],
      name_en: [
        { required: true, message: t('admin.speakers.form.nameEnRequired'), trigger: 'blur' },
        { max: 100, message: t('admin.speakers.form.nameEnLength'), trigger: 'blur' }
      ],
      bio_en: [
        { required: true, message: t('admin.speakers.form.bioEnRequired'), trigger: 'blur' },
        { min: 10, message: t('admin.speakers.form.bioEnLength'), trigger: 'blur' }
      ],
      bio_zh: [
        { min: 10, message: t('admin.speakers.form.bioZhLength'), trigger: 'blur' }
      ]
    }

    // 分页数据
    const pagination = reactive({
      page: 1,
      pageSize: 20,
      total: 0
    })

    // 获取数据
    const fetchData = async () => {
      loading.value = true
      try {
        const params = {
          page: pagination.page,
          per_page: pagination.pageSize,
          keyword: searchForm.keyword || undefined
        }

        const response = await getSpeakers(params)
        if (response.success) {
          tableData.value = response.data
          pagination.total = response.pagination.total
        } else {
          ElMessage.error(response.message || t('common.error'))
        }
      } catch (error) {
        console.error('获取演讲者列表失败:', error)
        ElMessage.error(t('common.error'))
      } finally {
        loading.value = false
      }
    }

    // 搜索
    const handleSearch = () => {
      pagination.page = 1
      fetchData()
    }

    // 重置
    const handleReset = () => {
      searchForm.keyword = ''
      pagination.page = 1
      fetchData()
    }

    // 刷新
    const handleRefresh = () => {
      fetchData()
    }

    // 添加
    const handleAdd = () => {
      isEdit.value = false
      resetForm()
      formVisible.value = true
    }

    // 查看详情
    const handleView = (row) => {
      currentRecord.value = row
      detailVisible.value = true
    }

    // 编辑
    const handleEdit = (row) => {
      isEdit.value = true
      currentRecord.value = row
      Object.assign(form, {
        name_zh: row.name_zh,
        name_en: row.name_en || '',
        bio_zh: row.bio_zh,
        bio_en: row.bio_en || '',
        avatar_temp_path: '',
        video_temp_path: '',
        video_url: row.video_url || '',
        sort_order: row.sort_order
      })
      formVisible.value = true
    }

    // 保存
    const handleSave = async () => {
      if (!formRef.value) return

      try {
        await formRef.value.validate()
        saving.value = true

        const formData = { ...form }
        let response

        if (isEdit.value) {
          response = await updateSpeaker(currentRecord.value.id, formData)
        } else {
          response = await createSpeaker(formData)
        }

        if (response.success) {
          ElMessage.success(t('common.saveSuccess'))
          formVisible.value = false
          fetchData()
        } else {
          ElMessage.error(response.message || t('common.error'))
        }
      } catch (error) {
        console.error('保存失败:', error)
        ElMessage.error(t('common.error'))
      } finally {
        saving.value = false
      }
    }

    // 删除
    const handleDelete = async (row) => {
      try {
        await ElMessageBox.confirm(
          t('common.deleteConfirm'),
          t('common.warning'),
          {
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel'),
            type: 'warning'
          }
        )

        const response = await deleteSpeaker(row.id)
        if (response.success) {
          ElMessage.success(t('common.deleteSuccess'))
          fetchData()
        } else {
          ElMessage.error(response.message || t('common.error'))
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error)
          ElMessage.error(t('common.error'))
        }
      }
    }

    // 头像文件变更处理
    const handleAvatarChange = async (file) => {
      // 处理拖拽上传和点击上传的文件对象差异
      const rawFile = file.raw || file

      if (!beforeAvatarUpload(rawFile)) {
        return
      }

      try {
        const response = await uploadSpeakerAvatar(rawFile)
        if (response.success) {
          form.avatar_temp_path = response.temp_path
          ElMessage.success(t('admin.speakers.upload.avatarSuccess'))
        } else {
          ElMessage.error(response.message || t('admin.speakers.upload.avatarError'))
        }
      } catch (error) {
        console.error('头像上传失败:', error)
        ElMessage.error(t('admin.speakers.upload.avatarError'))
      }
    }

    // 视频文件变更处理
    const handleVideoChange = async (file) => {
      if (!beforeVideoUpload(file.raw)) {
        return
      }

      try {
        const response = await uploadSpeakerVideo(file.raw)
        if (response.success) {
          form.video_temp_path = response.temp_path
          ElMessage.success(t('admin.speakers.upload.videoSuccess'))
        } else {
          ElMessage.error(response.message || t('admin.speakers.upload.videoError'))
        }
      } catch (error) {
        console.error('视频上传失败:', error)
        ElMessage.error(t('admin.speakers.upload.videoError'))
      }
    }

    // 上传错误
    const handleUploadError = (error) => {
      console.error('上传失败:', error)
      ElMessage.error(t('admin.speakers.upload.error'))
    }

    // 头像上传前验证
    const beforeAvatarUpload = (file) => {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        ElMessage.error(t('admin.speakers.upload.avatarTypeError'))
        return false
      }
      if (!isLt2M) {
        ElMessage.error(t('admin.speakers.upload.avatarSizeError'))
        return false
      }
      return true
    }

    // 视频上传前验证
    const beforeVideoUpload = (file) => {
      const isVideo = file.type.startsWith('video/')
      const isLt50M = file.size / 1024 / 1024 < 50

      if (!isVideo) {
        ElMessage.error(t('admin.speakers.upload.videoTypeError'))
        return false
      }
      if (!isLt50M) {
        ElMessage.error(t('admin.speakers.upload.videoSizeError'))
        return false
      }
      return true
    }

    // 重置表单
    const resetForm = () => {
      Object.assign(form, {
        name_zh: '',
        name_en: '',
        bio_zh: '',
        bio_en: '',
        avatar_temp_path: '',
        video_temp_path: '',
        video_url: '',
        sort_order: null
      })
      if (formRef.value) {
        formRef.value.clearValidate()
      }
    }

    // 分页大小改变
    const handleSizeChange = (size) => {
      pagination.pageSize = size
      pagination.page = 1
      fetchData()
    }

    // 当前页改变
    const handleCurrentChange = (page) => {
      pagination.page = page
      fetchData()
    }

    // 格式化日期
    const formatDate = (dateString) => {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }


    // 组件挂载时获取数据
    onMounted(() => {
      fetchData()
    })

    return {
      loading,
      saving,
      tableData,
      searchForm,
      form,
      formRules,
      pagination,
      detailVisible,
      formVisible,
      isEdit,
      currentRecord,
      formRef,
      fetchData,
      handleSearch,
      handleReset,
      handleRefresh,
      handleAdd,
      handleView,
      handleEdit,
      handleSave,
      handleDelete,
      handleAvatarChange,
      handleVideoChange,
      handleUploadError,
      beforeAvatarUpload,
      beforeVideoUpload,
      handleSizeChange,
      handleCurrentChange,
      formatDate,
      previewFile
    }
  }
}
</script>

<style scoped>
.admin-speakers {
  padding: 0;
}

.search-section,
.action-section,
.table-section {
  margin-bottom: 20px;
}

.search-form {
  padding: 10px 0;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.pagination-section {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

/* 详情弹窗样式优化 */
.speaker-detail-dialog .el-dialog__body {
  padding: 30px;
}

.detail-content {
  padding: 0;
}

/* 头部信息区域 */
.speaker-header {
  display: flex;
  align-items: flex-start;
  gap: 30px;
  margin-bottom: 30px;
  padding: 25px;
  background: #667eea;
  border-radius: 12px;
  color: white;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
}

.avatar-section {
  flex-shrink: 0;
}

.speaker-avatar {
  border: 4px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.speaker-avatar:hover {
  transform: scale(1.05);
}

.basic-info {
  flex: 1;
  min-width: 0;
}

.speaker-name {
  margin: 0 0 15px 0;
  font-size: 28px;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.speaker-name-en {
  margin: 0 0 15px 0;
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  font-style: italic;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.speaker-id {
  margin-bottom: 15px;
}

.speaker-id .el-tag {
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  font-weight: 500;
}

.created-time {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  opacity: 0.9;
}

/* 区域标题样式 */
.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9ecef;
}

.section-title .el-icon {
  color: #667eea;
  font-size: 20px;
}

/* 简介区域 */
.bio-section {
  margin-bottom: 30px;
}

.bio-content {
  background: linear-gradient(145deg, #f8f9fa, #ffffff);
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.bio-content p {
  margin: 0;
  line-height: 1.8;
  color: #495057;
  font-size: 15px;
}

/* 视频播放区域 */
.video-section {
  margin-bottom: 20px;
}

.video-container {
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  position: relative;
}

.speaker-video {
  width: 100%;
  max-height: 450px;
  display: block;
  border-radius: 12px;
}

/* 底部按钮区域 */
.dialog-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
}

.dialog-footer .el-button {
  padding: 12px 30px;
  font-weight: 500;
}

.video-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

/* 头像上传样式 */
.avatar-upload {
  .upload-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 120px;
    /* border: 2px dashed #d9d9d9; */
    /* border-radius: 8px; */
    /* background-color: #fafafa; */
    transition: all 0.3s ease;
    cursor: pointer;

    .upload-icon {
      font-size: 32px;
      color: #8c939d;
      margin-bottom: 12px;
    }

    .upload-text {
      text-align: center;

      p {
        margin: 0;
        color: #606266;

        &.upload-hint {
          font-size: 12px;
          color: #909399;
          margin-top: 4px;
        }
      }
    }

    .upload-success {
      display: flex;
      align-items: center;
      margin-top: 12px;
      padding: 8px 16px;
      background-color: #f0f9ff;
      border: 1px solid #b3d8ff;
      border-radius: 4px;
      color: #409eff;

      .success-icon {
        margin-right: 8px;
        font-size: 16px;
      }
    }
  }

  .el-upload-dragger {
    border: none;
    background: transparent;
    width: 100%;
    height: auto;
    padding: 0;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .speaker-detail-dialog {
    width: 95% !important;
  }

  .speaker-header {
    flex-direction: column;
    text-align: center;
  }

  .basic-info {
    margin-left: 0;
    margin-top: 20px;
  }
}
</style>